import { useEffect } from "react";

let activeLocks = 0;
let restoreOverflow: (() => void) | undefined;

/**
 * Locks page scroll (both axes) while `locked` is true.
 * Sets overflow: hidden on both <html> and <body> for maximum
 * browser compatibility (prevents fixed overlays from expanding
 * when the page has horizontal overflow).
 */
export function useScrollLock(locked: boolean) {
  useEffect(() => {
    if (!locked) return;

    if (activeLocks === 0) {
      const html = document.documentElement;
      const body = document.body;

      const prevHtml = html.style.overflow;
      const prevBody = body.style.overflow;

      html.style.overflow = "hidden";
      body.style.overflow = "hidden";
      restoreOverflow = () => {
        html.style.overflow = prevHtml;
        body.style.overflow = prevBody;
      };
    }
    activeLocks += 1;

    return () => {
      activeLocks -= 1;
      if (activeLocks === 0) {
        restoreOverflow?.();
        restoreOverflow = undefined;
      }
    };
  }, [locked]);
}
